export const NgDocAngularEntities = [
	'Component',
	'Directive',
	'Pipe',
	'Injectable',
	'NgModule',
] as const;
